import React, { cloneElement } from 'react';
import { Avatar, Box, Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import CAppPaper from '../../../app/components/CAppPaper';
import AppCustomIcon from '../../../app/features/icon/AppIcon';
import DocumentRoutes from '../DocumentRoutes';
import langDocumentFiles from '../langs/langDocumentFiles';

export type CDocumentExpertiseItemProps = {
	investmentTypeTag: string;
	nbDocumentFiles: number;
	icon: JSX.Element;
	name: string;
	nbInvestFunds?: number;
	isCompanyDocument?: boolean;
};

const CDocumentExpertiseItem = (props: CDocumentExpertiseItemProps) => {
	const { icon, name, investmentTypeTag, nbDocumentFiles, nbInvestFunds, isCompanyDocument } = props;

	const { t } = useTranslation();

	const theme = useTheme();
	const navigate = useNavigate();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const handleExplore = () => {
		navigate(
			isCompanyDocument
				? HAppRoutes.getPath(DocumentRoutes.documents_company.tag)
				: HAppRoutes.getPath(DocumentRoutes.documents_expertise.tag, {
						investExpertiseTag: investmentTypeTag,
				  }),
		);
	};

	return (
		<CAppPaper
			className="expertise-item"
			id={`expertise-item-${investmentTypeTag}`}
			color="default"
			variant="outlined"
			style={{
				cursor: 'pointer',
				padding: isMobile ? '15px' : '20px',
			}}
			onClick={() => handleExplore()}
		>
			<Grid container spacing={0} margin={0} alignItems="center">
				<Grid item xs={3} sm={3}>
					<Avatar
						sx={{
							width: isMobile ? '47px' : '60px',
							height: isMobile ? '47px' : '60px',

							backgroundColor: 'rgba(42, 189, 187, 0.15)',
						}}
					>
						{cloneElement(icon, {
							style: {
								width: '34px',
								height: '34px',
								color:
									theme.palette.mode === 'dark'
										? theme.palette.secondary.main
										: theme.palette.primary.main,
							},
						})}
					</Avatar>
				</Grid>
				<Grid item xs={9} sm={9} style={{ display: 'flex', flexDirection: 'column' }}>
					<div style={{ position: 'relative' }}>
						<div
							style={{
								textDecoration: 'none',
								position: 'absolute',
								right: '0px',
								fontFamily: "'Poppins'",
								fontStyle: 'normal',
								fontWeight: '500',
								fontSize: '0.9rem',
								lineHeight: '1.5',
								display: 'inline-block',
								color: theme.palette.mode === 'dark' ? '#FFF' : theme.palette.primary.main,
							}}
						>
							<AppCustomIcon tag="arrow-right" style={{ verticalAlign: 'middle' }} />
						</div>
						<Typography
							variant="h3"
							component="h3"
							style={{
								margin: '0px',
								fontFamily: "'Poppins'",
								fontStyle: 'normal',
								fontWeight: '600',
								fontSize: '1rem',
								lineHeight: '1.5',
							}}
						>
							{name}
						</Typography>
						<Stack
							direction="row"
							spacing={3}
							sx={{ marginTop: '5px', fontSize: '0.85rem', fontWeight: 300 }}
						>
							{nbInvestFunds && (
								<Stack direction="row" spacing={1} alignItems="center">
									<AppCustomIcon tag="expertises" color="secondary" sx={{ fontSize: '1rem' }} />
									<Box>{t(langDocumentFiles.x_funds.tag, { count: nbInvestFunds })}</Box>
								</Stack>
							)}
							<Stack direction="row" spacing={1} alignItems="center">
								<AppCustomIcon tag="folders" color="secondary" sx={{ fontSize: '1rem' }} />{' '}
								<Box>
									{t(!isMobile ? langDocumentFiles.x_documents.tag : langDocumentFiles.x_docs.tag, {
										count: nbDocumentFiles,
									})}
								</Box>
							</Stack>
						</Stack>
					</div>
				</Grid>
			</Grid>
		</CAppPaper>
	);
};

export default CDocumentExpertiseItem;
